export default __webpack_public_path__ + "static/media/picture-inpicture-icon.9dd2d5a2.svg";